import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resolveShortLinkService } from "@/services/deals.service";
import { PUBLIC_ROUTES } from "@/routes/url";

/**
 * `/u/:code` — the short link in a text message. Swaps the code for the in-app
 * path and replaces itself, so Back doesn't bounce through it. The destination
 * does its own sign-in check; an unknown code goes to login.
 */
export default function ShortLink() {
  const { code = "" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    resolveShortLinkService(code)
      // In-app paths only — "//host" would be another site.
      .then((path) => navigate(path.startsWith("/") && !path.startsWith("//") ? path : PUBLIC_ROUTES.LOGIN, { replace: true }))
      .catch(() => navigate(PUBLIC_ROUTES.LOGIN, { replace: true }));
  }, [code, navigate]);

  return <p className="mt-24 text-center text-sm text-stone">Opening your update…</p>;
}
